import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgTransactionIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M5 8h14m0 0-3 3m3-3-3-3M19 16H5m0 0 3 3m-3-3 3-3"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgTransactionIcon);
const Memo = memo(ForwardRef);
export default Memo;
